import '../css/page.css';
import { Container, Row } from 'react-bootstrap';
import InfoButton from '../components/infobutton.js';

function Page1() {
  return (
    <div className='ContentWrapper' style={{background: 'transparent'}}>
      <div id='HeadingContainer'>
        <Container>
          <Row>
            <h1 className='MegaPageHeading'>
              Your future <span className='no-wrap'>starts <b style={{ color: '#1E3A8A' }}>here</b></span>.
            </h1>
          </Row>
          <Row style={{paddingTop: '0.5rem'}}>
            <h2 className='MegaPageSubHeading'>
              <b>PathWay</b> uses AI to get you into the best universities in the world.
            </h2>
          </Row>
          <Row style={{paddingTop: '1.5rem'}}>
            <p>Pre-register to unlock 30% Off!</p>
          </Row>
          <Row style={{justifyContent: 'center'}}>
            <InfoButton />
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Page1;
